export default __webpack_public_path__ + "static/media/email-icon.eee1baa7.svg";